import { MdNoDrinks, MdReportProblem } from "react-icons/md";

const DrugAcoholPolicy = () => {
  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Hero Section */}
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
                Drug & Alcohol <span className="text-yellow-400">Policy</span>
              </h2>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <div className="bg-black text-white p-4 sm:p-6 md:p-8 mb-6 shadow-xl rounded-xl md:rounded-2xl border-l-[6px] md:border-l-[8px] border-green-700 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/10 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
          <p className="text-sm sm:text-base md:text-lg leading-relaxed font-bold relative z-10 italic">
            Being under the influence of alcohol or drugs can seriously impair an individual’s judgment and reactions leading to an increased risk of accidents and injuries occurring.
          </p>
          <p className="mt-3 text-gray-400 font-medium text-xs sm:text-sm relative z-10 leading-relaxed">
            The aim of this policy is to ensure the safety of all employees, workers, and visitors by having clear rules in place regarding use and possession of alcohol and drugs.
          </p>
        </div>

        <div className="bg-white rounded-xl md:rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="p-4 sm:p-6 md:p-8">
            <h2 className="text-lg sm:text-xl md:text-2xl font-black text-black mb-6 uppercase tracking-tighter flex items-center gap-3">
              Policy Framework
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 mb-6">
              <div className="space-y-3 sm:space-y-4">
                <div className="p-4 sm:p-5 bg-gray-50 rounded-xl border border-gray-100 hover:border-green-700 transition-all">
                  <h4 className="text-[11px] sm:text-xs font-black text-green-700 uppercase tracking-widest mb-2">Random Testing</h4>
                  <p className="text-black font-medium leading-relaxed text-xs sm:text-sm">
                    All employees of BEDC Electricity PLC may be subject to random drug/alcohol testing, including examinations for drug abuse and excessive alcohol use.
                  </p>
                </div>
                <div className="p-4 sm:p-5 bg-gray-50 rounded-xl border border-gray-100 hover:border-green-700 transition-all">
                  <h4 className="text-[11px] sm:text-xs font-black text-green-700 uppercase tracking-widest mb-2">Medical Excellence</h4>
                  <p className="text-black font-medium leading-relaxed text-xs sm:text-sm">
                    Frequency of the random testing shall be adequate: an effective deterrent that all employees are checked at least annually either through random testing or routine medical examination.
                  </p>
                </div>
              </div>

              <div className="p-4 sm:p-6 bg-white rounded-xl border-2 border-dashed border-gray-100 flex flex-col justify-center">
                <p className="text-gray-500 font-medium leading-relaxed text-xs sm:text-sm italic">
                  "BEDC acknowledges the importance of non-alcohol/drug abuse within the HSE efficiency of its operations; therefore compliance with this policy forms an integral part for system maintenance."
                </p>
              </div>
            </div>

            <div className="bg-red-50 border-l-[6px] sm:border-l-[8px] border-red-600 p-4 sm:p-6 rounded-xl shadow-md">
              <div className="flex flex-col md:flex-row items-center gap-4 sm:gap-6">
                <div className="bg-white p-3 sm:p-4 rounded-xl shadow">
                  <MdNoDrinks className="text-3xl sm:text-4xl text-red-600" />
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-black text-red-700 uppercase mb-1 tracking-tight">Strict Prohibition</h3>
                  <p className="text-gray-900 font-bold text-xs sm:text-sm leading-relaxed">
                    Bringing in drugs and/or alcohol into BEDC offices and facilities is strictly
                    <span className="bg-red-600 text-white px-1.5 py-0.5 rounded mx-1 text-[11px] sm:text-xs">PROHIBITED</span>
                    and will be grounds for disciplinary proceedings. BEDC may carry out unannounced searches for drugs and alcohol within the working premises.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-6 p-4 sm:p-5 bg-gray-50 rounded-xl border border-gray-100 flex items-center gap-4">
              <div className="bg-yellow-400 p-2.5 rounded-lg shadow-sm flex-shrink-0">
                <MdReportProblem className="text-black text-xl" />
              </div>
              <p className="text-black font-black uppercase text-[10px] sm:text-[11px] tracking-widest">
                BEDC affirms that any imposed client drug and search policies shall be followed in full by all employees.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrugAcoholPolicy;